import React from "react";
import { Routes, Route } from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import Home from "../components/Home";
import PackagesDescription from "../components/PackagesDescription";
import AllPackages from "../components/AllPackages";
import Enquiry from "../components/Enquiry";
import Contact from "../components/Contact";
import AboutUs from "../components/AboutUs";
import PackagesCards from "../components/PackagesCards";
import Review from "../components/Review";
import CircleShape from "../components/CircleShape";
import HomePackages from "../components/HomePackages";
import Payment from "../components/Payment";
import PrivacyPolicy from "../components/PrivacyPolicy";
import TermsAndConditions from "../components/TermsAndConditions";
import ThanksPage from "../components/ThanksPage";
import PopularPackageLinks from "../components/PopularPackageLinks";
import CountryLandingPage from "../components/CountryLandingPage";
import AnimatedPackageList from "../components/AnimatedPackageList";

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<MainLayout />}>
                <Route
                    index
                    element={
                        <>
                            <Home />
                            <HomePackages />
                            <PackagesCards />
                            <PopularPackageLinks />
                        </>
                    }
                />
                <Route path="packages-description" element={<PackagesDescription />} />
                <Route path="all-packages" element={<AllPackages />} />
                <Route path="enquiry-page" element={<Enquiry />} />
                <Route path="contact-us" element={<Contact />} />
                <Route path="about-us" element={<AboutUs />} />
                <Route path="pay" element={<Payment />} />
                <Route path="/destination/:countryName" element={<CountryLandingPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                <Route path="/thank-you" element={<ThanksPage />} />
                <Route path="/all_packages" element={<AnimatedPackageList />} />
            </Route>
        </Routes>
    );
};

export default AppRoutes;
